var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import useMeasure from '@empiriecom/module-components/hooks/useMeasure';
import { animated, useSpring } from 'react-spring';
import { isClientSide } from '../../utils/EnvironmentTest';
import Teaser from './Fragments/Teaser';
import SheetContent from './Fragments/Content';
import IntlProvider from './IntlProvider';
var StyledCurtain = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: ", ";\n  transition: opacity 1s;\n  z-index: 998;\n"], ["\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: ", ";\n  transition: opacity 1s;\n  z-index: 998;\n"])), function (_a) {
    var base = _a.theme.base;
    return base.color.textTransparent;
});
var AnimatedSheetWrapper = styled(animated.div)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  color: ", ";\n  position: fixed;\n  bottom: 0;\n  overflow: hidden;\n  will-change: height;\n  z-index: 999;\n"], ["\n  width: 100%;\n  color: ", ";\n  position: fixed;\n  bottom: 0;\n  overflow: hidden;\n  will-change: height;\n  z-index: 999;\n"])), function (_a) {
    var global = _a.theme.global;
    return global.color.textDark;
});
var Sheet = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 0.938rem;\n  box-sizing: content-box;\n"], ["\n  font-size: 0.938rem;\n  box-sizing: content-box;\n"])));
var setCloseTime = function () { };
var day;
var newsletterSheetClosed;
if (isClientSide()) {
    setCloseTime = function () { return localStorage.setItem('newsletterSheetClosed', "" + Date.now()); };
    day = 1000 * 60 * 60 * 24;
    newsletterSheetClosed = parseInt(localStorage.getItem('newsletterSheetClosed') || '0', 10);
}
var NewsletterSheet = function (_a) {
    var companyid = _a.companyid;
    // The close time margin of the newsletter should be 60 days
    if (newsletterSheetClosed + day * 60 > Date.now()) {
        return null;
    }
    var _b = useState(false), stateIsSheetVisible = _b[0], setStateIsSheetVisible = _b[1];
    var _c = useMeasure(), refSheetTeaser = _c[0], sheetTeaserHeight = _c[1].height;
    var _d = useState(false), stateIsSheetOpen = _d[0], setStateIsOpen = _d[1];
    var _e = useMeasure(), refSheetContent = _e[0], sheetContentHeight = _e[1].height;
    var _f = useState(sheetContentHeight), currentSheetContentHeight = _f[0], setCurrentSheetContentHeight = _f[1];
    var onTeaserClick = function () { return setStateIsOpen(function (isContentOpen) { return !isContentOpen; }); };
    var animateToHeight = stateIsSheetOpen ? currentSheetContentHeight : sheetTeaserHeight;
    var animatedSheetHeight = useSpring({
        config: { tension: 210, friction: 40 },
        height: stateIsSheetVisible ? animateToHeight : 0,
    }).height;
    var onCloseIconClick = function (event) {
        event.stopPropagation();
        setCloseTime();
        setStateIsSheetVisible(function (isSheetStateOpen) { return !isSheetStateOpen; });
    };
    useEffect(function () {
        setStateIsSheetVisible(function (isSheetStateVisible) { return !isSheetStateVisible; });
    }, []);
    return (React.createElement(IntlProvider, { companyId: companyid },
        React.createElement(StyledCurtain, { style: {
                opacity: Number(stateIsSheetOpen),
                pointerEvents: stateIsSheetOpen ? 'all' : 'none',
            } }),
        React.createElement(AnimatedSheetWrapper, { id: "sheet", "data-testid": "sheet", "aria-hidden": !stateIsSheetVisible, style: {
                height: animatedSheetHeight,
            } },
            React.createElement(Sheet, null,
                React.createElement("div", { ref: refSheetTeaser },
                    ' ',
                    React.createElement(Teaser, { onTeaserClick: onTeaserClick, onCloseIconClick: onCloseIconClick })),
                React.createElement("div", { ref: refSheetContent },
                    ' ',
                    React.createElement(SheetContent, { isSheetOpen: stateIsSheetOpen, sheetContentHeightSetup: {
                            currentSheetContentHeight: currentSheetContentHeight,
                            setCurrentSheetContentHeight: setCurrentSheetContentHeight,
                        } }))))));
};
export default NewsletterSheet;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map